import { bunja } from 'bunja';
import { atom } from 'jotai';

import { PathnameScope } from '@flipster/react/providers/route';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

export const symbolLeftBunja = bunja(() => {
  const { symbolInfoExistsAtom, isSpotAtom } = bunja.use(tradeSymbolBunja);
  const pathname = bunja.use(PathnameScope);
  const isSpotPath = pathname.includes('/spot/');

  const isNotFoundAtom = atom((get) => {
    if (!get(symbolInfoExistsAtom)) return false;
    const isSpot = Boolean(get(isSpotAtom));
    return isSpotPath !== isSpot;
  });

  return { isSpotPath, isNotFoundAtom };
});
symbolLeftBunja.debugLabel = 'symbolLeftBunja';
